import type { Taxon } from '../generated/graphql'

const genreTaxonCode = 'Genre'

export function taxonCodeEqualsGenre(taxon: Taxon) {
  return taxon.parent?.code === genreTaxonCode
}
